import Box from "@components/Box";
import AsideNew from "@components/CaseStudyComponents/AsideNew";
import TestimonialSectionCaseStudy from "@components/LandingPageComponents/TestimonialSectionCaseStudy";
import { AppButton } from "@components/Typography";
import "keen-slider/keen-slider.min.css";
import Image from "next/image";
import React, { FC } from "react";
import AchievementCard from "../../components/CaseStudyComponents/AchievementCard";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import NewLayout from "../../components/new-ui/Layout";

const goireland: FC = () => {
    const cardData = [
        {
            imgpath: "https://assets.gallabox.com/gb-home/go-ireland/goireland-icon1.png",
            title: "Number of Students and",
            count: "2,00,000",
            by: "Professionals Served",
            borderColor: "#ACDAF1",
            boxShadowColor: "white",
            fontColor: "#4299E1",
            gradient: "linear-gradient(105.67deg, rgba(215, 235, 245, 0.2) 0%, #D7EBF5 95.66%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/property2x/property2x-icon2.png",
            title: "Improvement in Campaign ",
            count: "43%",
            by: "Performance",
            borderColor: "#9AE6B4",
            boxShadowColor: "white",
            fontColor: "#38A169",
            gradient: "linear-gradient(285.78deg, #ECF8E1 3.17%, rgba(236, 248, 225, 0.2) 96.84%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/go-ireland/goireland-icon3.png",
            title: "Increase in Customer",
            count: "54%",
            by: "Satisfaction Rate",
            borderColor: "#DEBEF3",
            boxShadowColor: "white",
            fontColor: "#805AD5",
            gradient: "linear-gradient(285.94deg, #EFE1F8 1.79%, rgba(239, 225, 248, 0.2) 98.89%)",
        },
    ];
    const redBoxPoints = ["unnurtured event leads turning cold", "Lead forms becoming a bottleneck", "Lack of a unified support dashboard"];
    const greenBoxPoints = ["Event Conversions Soared by 20%", "Skyrocketing Lead Conversions by 39% ", "Response Rates Improved by 32%"];
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    return (
        <NewLayout
            title="GoIreland’s Success Story: Improved Transparency and Increased Conversions"
            description="GoIreland increased conversions by 39% with personalized WhatsApp messages. See how Gallabox can help you achieve similar results."
            canonical="https://gallabox.com/case-study/goireland"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/go-ireland/goireland-og-new.jpg" }}
        >
            <header className="grid lg:pt-20 pt-0 pb-4 goireland-header">
                <div className="hero-section h-full flex flex-col-reverse xl:flex-row px-4 xl:justify-between pt-12 lg:pt-0 mx-auto">
                    <div className="w-full h-full lg:w-1/2 lg:space-y-10 space-y-2 lg:pt-20 pt-10 order-1 lg:order-1 lg:overflow-hidden border-transparent">
                        <Image
                            width={483}
                            height={310}
                            src="https://assets.gallabox.com/gb-home/go-ireland/goireland-header.png"
                            objectFit="scale-down"
                            alt="goireland-header-image"
                        />
                    </div>
                    <div className="h-full w-full lg:w-1/2 order-2 lg:order-2 lg:space-y-6 space-y-2 lg:pt-20">
                        <h1 className="font-semibold text-3xl lg:text-4xl lg:leading-tight" style={{ color: "#234E52" }}>
                            GoIreland’s Success Story : Improved Transparency and Increased Conversions
                        </h1>
                        <div className="text-xl text-biscay" style={{ color: "#234E52" }}>
                            GoIreland increased conversions by 39% with personalized WhatsApp messages. See how Gallabox can help you achieve similar results.
                        </div>
                    </div>
                </div>
            </header>

            <div>
                <section className="max-w-6xl mx-auto flex flex-col items-center sm:flex-row gap-5 my-20 justify-between ">
                    {cardData.map((eachobj) => {
                        return (
                            <AchievementCard
                                key={""}
                                imagePath={eachobj.imgpath}
                                imageTitle={eachobj.title}
                                count={eachobj.count}
                                by={eachobj.by}
                                borderColor={eachobj.borderColor}
                                boxShadowColor={eachobj.boxShadowColor}
                                fontColor={eachobj.fontColor}
                                gradient={eachobj.gradient}
                            />
                        );
                    })}
                </section>
            </div>
            <div className=" mx-auto mt-20 lg:px-0 px-4">
                <div className="max-w-6xl mx-auto flex flex-col sm:flex-row gap-8">
                    <div className=" mx-auto lg:w-64  ">
                        <AsideNew
                            data={[
                                {
                                    title: "Company",
                                    content: "GoIreland",
                                },
                                {
                                    title: "Industry",
                                    content: "Education - Study Abroad",
                                },
                                {
                                    title: "Employees",
                                    content: "21-50",
                                },

                                {
                                    title: "Features Used",
                                    content: [
                                        " Shared Team Inbox",
                                        "WhatsApp Broadcasts",
                                        "WhatsApp Widget for Website",
                                        "Shared Number for Support Team",
                                        "Out-of-the-Box Integrations",
                                    ],
                                },
                                {
                                    title: "Chats per Month",
                                    content: "5k+",
                                },
                                {
                                    title: "website",
                                    link: "www.go.study",
                                    content: "www.go.study",
                                },
                            ]}
                        />
                        <div className=" sm:sticky top-24 pt-4 pb-10">
                            <Box title="Pain Points 🥲" points={redBoxPoints} bgColor="red-50" textColor="red-700" />
                            <Box title="Results 🤩" points={greenBoxPoints} bgColor="green-50" textColor="green-600" />
                        </div>
                    </div>
                    <main className="  lg:px-8 px-4    ">
                        <div>
                            <h2 className="lg:text-5xl text-2xl font-bold pb-10" style={{ color: "#4A5568" }}>
                                GoIreland: The Golden Ticket to Study in Ireland
                            </h2>
                            <p className="lg:text-lg text-base pb-10 text-gray-500 ">
                                GoIreland, considered India&apos;s numero uno confidante for all things about studying in Ireland, has spread its wings all over the subcontinent.
                                They&apos;re all about doling out advice and guidance to India&apos;s wise young owls, eager to stretch their learning wings in the land of
                                shamrocks - Ireland.
                            </p>
                            <p className="lg:text-lg text-base pb-10 text-gray-500 ">
                                Renowned, respected, and really into promoting Ireland as the go-to study destination, GoIreland counsellors carry heaps of experience and an
                                impressive trophy cabinet of accolades!
                            </p>
                            <p className="lg:text-lg text-base  text-gray-500 pb-20">
                                Now, the crew at GoIreland isn&apos;t just throwing darts at a board - they&apos;re equipped with a big ol&apos; knowledge arsenal on all things
                                Irish education - the universities, the courses, and even the scholarships. They&apos;re masters at crafting personalised study pathways to Ireland!
                            </p>
                        </div>
                        <div>
                            <h2 className="lg:text-5xl text-2xl  font-bold pb-8" style={{ color: "#4A5568" }}>
                                The Obstacles Faced by GoIreland
                            </h2>
                            <div className="">
                                <p className="lg:text-lg text-base text-gray-500 pb-6">
                                    GoIreland, as an up-and-coming study abroad service provider, faced a number of challenges in the initial stages of their growth journey.
                                    Let&apos;s take a closer look…
                                </p>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold pb-8">Following up on high-intent leads from events</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-10">
                                        Trying to keep an eye on that elusive person who shows even a glimmer of interest in a bustling event is a challenge. That was precisely the
                                        hurdle GoIreland was trying to make a leap over. Keeping tabs on high-intent leads generated from busy events and fairs was like finding a
                                        needle in a haystack.
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold pb-8">Revamping the lead engagement process</h3>
                                    <p className="lg:text-lg text-base text-gray-500 pb-10">
                                        GoIreland was experiencing a problem with lead forms, as they were seeing a higher number of people abandoning the process of filling out
                                        lead information. They needed to not only eliminate lead forms but also find a viable and engaging way to interact with students. This was a
                                        puzzle they were eager to solve.
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold pb-8">Number unification for their support team</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-20 ">
                                        Their support team were scattered around, using different contact numbers. It’s like playing a game of Chinese whispers on a digital scale,
                                        making it difficult to collaborate on anything. The dire need for a unified number was obvious from the repetitive conversations and drop in
                                        efficiency.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h2 className="lg:text-4xl text-2xl  font-bold pb-10" style={{ color: "#4A5568" }}>
                                Mastering Customer Interaction with Gallabox
                            </h2>
                            <div className=" space-y-8">
                                <p className="lg:text-lg text-base  text-gray-500">
                                    GoIreland was aiming for scale and better conversion rates with Facebook and Instagram ads. However, managing leads and customer interactions
                                    that were initiated on their website or through these campaigns proved to be a daunting task.
                                </p>
                                <p className="lg:text-lg text-base  text-gray-500">
                                    Without a unified dashboard and equipped only with limited insights on campaign and team performance, their conversion rates took a major hit.
                                    As they were looking for ways to make the most out of WhatsApp inquiries made through their website, they stumbled upon Gallabox.
                                </p>
                                <p className="lg:text-lg text-base  text-gray-500 pb-10">
                                    Here&apos;s how Gallabox helped them overcome their challenges and achieve their business goals.
                                </p>
                                <div className="">
                                    <h3 className="text-2xl  text-gray-500 font-semibold pb-8">Improving Transparency with a Shared Team Inbox</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        In the realm of customer service, the importance of transparency cannot be overstated. Gallabox&apos;s Shared Team Inbox has an incredibly
                                        clear communication layout, improving their team&apos;s productivity by facilitating swift and engaging responses.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        GoIreland&apos;s marketing and sales found the shared inbox extremely effective, as it offered an overview of all chat activity across
                                        different channels. It provided valuable insights into the effectiveness of chat sessions and highlighted areas for improvement to optimize
                                        the team&apos;s performance.
                                    </p>
                                </div>
                                <div className="">
                                    <h3 className="text-2xl  text-gray-500 font-semibold pb-8">Re-Engaging Dormant Customers and Prospects</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        Previously, GoIreland a conducted series of offline events and fairs specifically designed for students. This initiative successfully
                                        generated a large number of high-intent leads. However, due to a lack of subsequent follow-up efforts, these potential customers remained
                                        dormant, and hence, no discernible conversions took place.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        Gallabox&apos;s broadcast feature helped GoIreland remedy this situation and helped engage potential customers with relevant content,
                                        nudging them towards conversion. The broadcast campaigns helped bolster brand recognition and increased overall sales resulting in a 32%
                                        increase in conversion rates.
                                    </p>
                                </div>
                                <div className="">
                                    <h3 className="text-2xl  text-gray-500 font-semibold pb-8">Improving Conversions with a WhatsApp Widget</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        GoIreland&apos;s strategy relied on a standard &apos;form and follow&apos; approach. The website showcased a short form for users to fill
                                        out and submit, and wait for a reply from customer service representatives.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        But, GoIreland noticed a considerable communication disconnect. Users often hesitated to interact with long, tedious forms that required
                                        filling out many fields, an activity which could take up to five minutes.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        That&apos;s when Gallabox&apos;s WhatsApp Wideget came into play, making it easier for users to connect directly with GoIreland&apos;s
                                        agents. This widget simplified lead collection by replacing the old form-fill-up system and paving the way for instant communication
                                    </p>
                                </div>
                                <TestimonialSectionCaseStudy
                                    testimonialData={{
                                        headerTitle:
                                            "Earlier a student would spend 15 to 30 minutes connecting with an agent, the widget immediately connects the student and the agent. Implementing the WhatsApp Widget led to a massive increase in user engagement and, ultimately, conversion rates.",
                                        avatarImg: "https://assets.gallabox.com/gb-home/go-ireland/goireland-owner.png",
                                        nameText: "Ilaya Bharathi",
                                        professionText: "Founder & CEO, GoIreland",
                                    }}
                                />
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            <section style={{ backgroundColor: "#FFED82" }} className="flex flex-col items-center justify-center">
                <div className="max-w-6xl mx-auto px-4 md:px-20 py-8">
                    <h2 className="font-bold lg:text-3xl text-base text-center text-yellow-800" style={{ fontSize: "26px" }}>
                        Are you ready to level up your <br /> customer engagement game, just like GoIreland did?
                    </h2>
                    <div className="flex justify-center mt-4">
                        {" "}
                        <AppButton buttonText="Get Started" href="https://app.gallabox.com/signup" />
                    </div>
                </div>
            </section>

            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />

            <style jsx>{`
                .goireland-header {
                    background-color: #def0bd;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 100vw;
                    height: 500px;
                }
                .goireland-header h1 {
                    font-family: Google Sans;
                    font-style: normal;
                    letter-spacing: 0.02em;
                    color: #162c6f;
                }
                .goireland-header .top-text {
                    font-weight: 500;
                    font-size: 30px;
                    line-height: 38px;
                }
                .goireland-header .bottom-text {
                    font-weight: 700;
                    font-size: 50px;
                    line-height: 64px;
                }
                .case-study-bluebox-slider {
                    font-family: "Google Sans";
                    font-style: normal;
                    letter-spacing: 0.05em;
                    color: #4a5568;
                    background-color: #ffffff;
                    box-shadow: 2.01005px 2.01005px 10.0503px rgba(51, 100, 250, 0.2), inset 0px 0px 10.0503px rgba(122, 152, 244, 0.1);
                    border-radius: 10.0503px;
                }
                .slider-profile-name {
                    font-weight: 700;
                    font-size: 22.1106px;
                    width: fit-content;
                    line-height: 28px;
                }
                .slider-content {
                    font-style: italic;
                    font-weight: 500;
                    font-size: 26.1307px;
                    line-height: 40px;
                    width: fit-content;
                }
                .slider-profile-about {
                    font-weight: 400;
                    font-size: 17.9834px;
                    line-height: 23px;
                    text-align: center;
                }
                .case-study-tag-filter {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14.9744px;
                    line-height: 19px;
                    letter-spacing: 0.02em;
                    color: #2d3748;
                }
                .case-study-filter-checkbox {
                    width: 18px;
                    height: 18px;
                    background-color: #ffffff;
                    border: 1.5px solid #0083ff;
                    border-radius: 2px;
                }
                .case-study-carousal {
                    border-radius: 10px;
                }
                .case-study-carousal-content {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 40px;
                    letter-spacing: 0.02em;
                    color: #ffffff;
                }
                .case-study-carousal .redirect {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 19px;
                    letter-spacing: 0.02em;
                    color: #bababa;
                }
                .case-study-carousal .redirect::after {
                    content: url("https://assets.gallabox.com/gb-home/case-study/redirect-arrow.png");
                    position: relative;
                    left: 4px;
                    top: 2px;
                }
                .carousal-img {
                    width: 530px;
                    background-color: #d9d9d9;
                    border-radius: 4.99649px;
                }
                .filter-title-case-study {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 500;
                    font-size: 15px;
                    line-height: 19px;
                    text-align: center;
                    letter-spacing: 0.02em;
                    color: #838383;
                }
                .slider-btn-right {
                    position: absolute;
                    top: 150px;
                    right: -35px;
                    z-index: 5;
                }
                .slider-btn-left {
                    position: absolute;
                    top: 150px;
                    left: -35px;
                    z-index: 5;
                }
                .slide-count-case-study {
                    width: 60px;
                    height: 60px;
                    color: #3364fa;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }
                .left-arrow {
                    width: 30px;
                    height: 30px;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }
                .right-arrow {
                    width: 30px;
                    height: 30px;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }

                @media (max-width: 35rem) {
                    .goireland-header {
                        background-size: contain;
                        height: 100%;
                    }
                    .goireland-header .top-text {
                        font-size: 20px;
                    }
                    .goireland-header .bottom-text {
                        font-size: 30px;
                        padding-inline: 1rem;
                        line-height: 35px;
                        margin-top: 0.7rem;
                    }
                    .case-study-carousal {
                        border-radius: 10px;
                    }
                    .carousal-img {
                        width: 100%;
                    }
                    .case-study-carousal-content {
                        font-size: 18px;
                        line-height: 28px;
                        padding-inline: 1rem;
                        margin-top: 0.5rem;
                        margin-bottom: 1rem;
                    }
                    .slide-count-case-study {
                        width: 50px;
                        height: 50px;
                    }
                    .left-arrow {
                        width: 30px;
                        height: 30px;
                    }
                    .right-arrow {
                        width: 30px;
                        height: 30px;
                    }
                    .slider-profile-name {
                        font-size: 19px;
                        line-height: 30px;
                    }
                    .slider-profile-about {
                        font-size: 18px;
                        line-height: 23px;
                    }
                    .slider-content {
                        font-size: 16px;
                        line-height: 23px;
                    }
                    .slider-btn-right {
                        top: 180px;
                        right: -5px;
                        width: 3rem;
                    }
                    .slider-btn-left {
                        top: 180px;
                        left: -5px;
                        width: 3rem;
                    }
                }
            `}</style>
        </NewLayout>
    );
};

export default goireland;
